// extracted by mini-css-extract-plugin
export default {"centered":"CheckoutSuccess_centered__H1+Id","actions":"CheckoutSuccess_actions__L7sa+"};